import {User, Customer, Receiver, Sender} from '../user/user';
import {Info} from './info';
import {Payment} from './payment';


export const TransactionStatus = {
  Approved: 'Approved',
  Compliance: 'Compliance',
  ComplianceHold: 'ComplianceHold',
  Hold: 'Hold',
  PostPayment: 'PostPayment',
  Paid: 'Paid',
  UnPaidCancel: 'UnPaidCancel',
  Cancel: 'Cancel',
  CancelRequest: 'CancelRequest',
  WaitingForDeposit: 'Wait For Deposit',
  started: 'Started',
  wait4deposit: 'Wait 4 Deposit',
  checking: 'Checking',
  holding: 'Holding',
  cancelled: 'Cancelled',
  confirmed: 'Confirmed',
  paid: 'Paid',
  invalidReceiver: '',
  OverSeasRequest: 'OverSeas Request'
};

export const InbTransactionStatus = {
  ReadyToPay: 'Ready to Pay',
  Paid: 'Paid',
  Pending: 'Pending',
  Checking: 'Checking',
  Cancelled: 'Cancelled',
  ForcePaid: 'ForcePaid',
  Approved: 'Approved'
};

export const FundSource = {
  BusinessIncome: 'Business Income',
  Investment: 'Investment',
  Loan: 'Loan (Borrow from others)',
  Lottery: 'Lottery',
  PartTimeJob: 'Part Time Job',
  Salary: 'Salary',
  Savings: 'Savings',
  Pension: 'Pension'
};

export const TransactionReason = {
  ForeignWorkersRemittance: 'Foreign Workers Remittance (Paycheck)',
  FamilyLivingExpenses: 'Family Living Expenses',
  SavingsOrInvestments: 'Savings or Investments',
  BusinessPayments: 'Business Payments',
  ShoppingOrBuying: 'Shopping or Buying'
};

export const BeneRelationship = {
  Brother_Sister: 'Brother/ Sister',
  BusinessPartner: 'Business Partner',
  Children: 'Children',
  Cousin: 'Cousin',
  Employee: 'Employee',
  Employer: 'Employer',
  Friends: 'Friends',
  Parents: 'Parents',
  Self: 'Self',
  Spouse: 'Spouse',
  Uncle_Auntie: 'Uncle/ Auntie',
  GrandParents: 'GrandFather/GrandMother',
  Nephew_Niece: 'Nephew/Niece'
};

export class Transaction {
  sender: Customer = new Customer();
  receiver: Receiver = new Receiver();
  payment: Payment = new Payment();
  info?: Info = new Info();
}

export class TransactionInb {
  sender: Sender = new Sender();
  receiver: Customer = new Customer();
  payment: Payment = new Payment();
  info?: Info = new Info();
}

export class TxnTotalAmount {
  deposit_total_amount?: number;
  payout_total_amount?: number;
  fee_total_amount?: number;
}

export class TransactionListItem {
  transaction_id: string;
  customer_id: string;
  sd_firstname: string;
  sd_middlename: string;
  sd_lastname: string;
  rc_idx: string;
  rc_firstname: string;
  rc_middlename: string;
  rc_lastname: string;
  rc_address: string;
  rc_zip_code:string;
  rc_street:string;
  rc_street2:string;
  rc_phone: string;
  rc_gender: string;
  rc_nationality: string;
  partner_name: string;
  partner_country: string;
  branch_name: string;
  deposit_amount: number;
  deposit_currency: string;
  deposit_type: string;
  fee: number;
  payout_amount: number;
  payout_currency: string;
  payout_type: string;
  payout_partner_id: string;
  payout_branch_code: string;
  payout_bank_account: string;
  payout_bank_code: string;
  payout_bank_name: string;
  reg_date: string;
  approve_date: string;
  end_date: string;
  status: string;
  customer_rate: string;
  agent_branch_name: string;
  agent_name: string;
  hb_res_id: string;
  relation: string;
  cancel_status: string;
  changename_status: string;
  transaction_reason?: string;
  source?: string;
}

export class InbTransactionListItem { // inbound list model
  transaction_id: string;
  customer_id: string;
  sd_firstname: string;
  sd_middlename: string;
  sd_lastname: string;
  sd_country: string;
  rc_idx: string;
  rc_firstname: string;
  rc_middlename: string;
  rc_lastname: string;
  rc_address: string;
  rc_phone: string;
  rc_gender: string;
  rc_nationality: string;

  partner_name: string;
  partner_country: string;
  branch_name: string;
  deposit_amount: number;
  deposit_currency: string;
  deposit_type: string;
  fee: number;
  payout_amount: number;
  payout_currency: string;
  payout_type: string;
  payout_partner_id: string;
  payout_branch_code: string;
  payout_bank_account: string;
  payout_bank_code: string;
  reg_date: string;
  approve_date: string;
  end_date: string;
  status: string;
  customer_rate: string;
  agent_branch_name: string;
  agent_name: string;

  // 추가
  bank_name?: string;
  account_number?: string;

  transaction_reason?: string;
  fundsource?: string;
  relation?: string;

  status_reason?: string;

  refunded? : string;
  refunded_date? : string;
}


export class TransactionDetail {
  approver_name: string;
  approve_date: string;
  reg_date: number;
  end_date: string;
  agent_name: string;
  transaction_status: string;
  transaction_id: string;
  pin_number: string;
  payout_partner_name: string;
  payout_partner_country: string;
  deposit_partner_name: string;
  deposit_branch_name: string;
  deposit_branch_code: string;
  deposit_type: string;
  sd_local_firstname: string;
  sd_local_middlename: string;
  sd_local_lastname: string;
  sd_firstname: string;
  sd_middlename: string;
  sd_lastname: string;
  sd_nationality: string; // 송금인 국적
  sd_phone1: string;
  sd_gender: string;
  sd_zip_code: string;
  sd_street: string;
  sd_street2: string;
  rc_firstname: string;
  rc_middlename: string;
  rc_lastname: string;
  rc_nationality: string;
  rc_phone: string;
  rc_gender: string;
  rc_address: string;
  rc_zip_code: string;
  rc_street: string;
  rc_street2: string;
  payout_type: string;
  payout_bank_name: string;
  payout_branch_name: string;
  payout_bank_account: string;
  deposit_amount: number;
  deposit_currency: string;
  deposit_rate: number; // (송금 통화)환율
  payout_rate: string; // (수취 통화)환율
  payout_amount: number;
  payout_currency: string;
  fee: number;
  customer_rate: number;
  transaction_reason: string;
  account_bank_name: string;
  account_number: string;
  customer_id: string;
  partner_customer_id: string;
  source: string;
  relation: string;
  status_reason: string;
  hb_res_id: string;
  aml_data: TxnAml;
  cancel_status: string;
  changename_status: string;

  od_account_number?: string;
  od_bank_name?: string;
  od_deposit_date?: string;

  rc_id_type: string;
  rc_id_number: string;

  partner_id?: string;
  deposit_account_type?: string;

  partner_code?: string;
  changename_rc_first?: string;
  changename_rc_middle?: string;
  changename_rc_last?: string;
  start_worker_type?: string;
  transaction_remark?: string;

  refunded?:string;
  refunded_date?:string;
}

export class TxnAml {
  transaction_id: string;
  rc_first: string;
  rc_last: string;
  rc_simil_name: string;
  rc_similarity: number;
  sd_first: string;
  sd_last: string;
  sd_simil_name: string;
  sd_similarity: number;
}

export class ReqCheckRemittance {
  transaction_id: string;
  customer_idx: string;
}

export class InbTransactionDetail {  // inbound TransactionDetail
  approver_type: string;
  approve_date: string;
  approver_name: string;
  reg_date: number;
  upd_date: string;
  end_date: string;
  agent_name: string;
  status: string;
  transaction_id: string;
  pin_number: string;
  deposit_partner_name: string;
  deposit_branch_name: string;
  deposit_type: string;
  partner_country: string;
  partner_name: string;
  sd_firstname: string;
  sd_middlename: string;
  sd_lastname: string;
  sd_nationality: string; // 송금인 국적
  sd_country: string;
  sd_city: string; // 송금 도시
  sd_phone: string;
  sd_gender: string;
  sd_zip_code: string;
  sd_address: string;
  sd_street: string;
  sd_street2: string;
  rc_firstname: string;
  rc_middlename: string;
  rc_lastname: string;
  rc_nationality: string;
  rc_phone: string;
  rc_gender: string;
  rc_country: string; // 거주 국가
  rc_city: string;
  rc_address: string;
  rc_zip_code: string;
  rc_street: string;
  rc_street2: string;
  rc_phone1_c?: string;
  rc_firstname_c?: string;
  rc_middlename_c?: string;
  rc_lastname_c?: string;
  payout_type: string;
  payout_bank_name: string;
  payout_branch_name: string;
  payout_bank_account: string;
  payout_bank_code: string;
  deposit_amount: number;
  deposit_currency: string;
  payout_amount: number;
  payout_currency: string;
  deposit_rate: number; // (송금 통화)환율
  payout_rate: string; // (수취 통화)환율
  fee: number;
  customer_rate: number;
  transaction_reason: string;
  customer_id: string;
  partner_customer_id: string;
  source: string;
  relation: string;

  partner_txn_id: string;
  txn_comment?: string;
  payout_pin_number?: string;
  pending_reason?: string;
  rc_coi_account_idx?: number;
  sd_partner?: string;

  account_holder?: string;
  aml_data: TxnAml;
  deposit_result?: string;
  deposit_result_code?: string;
  is_suspicious_account?: boolean;
  status_reason?: string;
}

export class UserTransactionList {
  txn_date: string;
  rc_firstName: string;
  rc_middleName: string;
  rc_lastName: string;
  sd_firstName: string;
  sd_middleName: string;
  sd_lastName: string;
  transferAmount: string;
  payoutAmount: string;
  deposit_currency: string;
  payout_currency: string;
  pin_number: string;
  payoutPartner: string;
  payoutBank: string;
  payoutBranch: string;
  payoutAccount: string;
  payoutType: string;
}

export class SubInfTransaction {
  idx : string;
  type : string;

  value : string;
  valueKor : string;
  valueJpn :string;
  valueVie :string;
  valueNep :string;
  valueBen :string;
  isSecondForeignLanguage : boolean;
  
  editMode : boolean = false;
  displayType : string;
  // isNew : boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/model/shared/transaction/transaction.ts